import { AxiosResponse } from "axios";
import { HttpService } from "@/core";
import { ResponseResp } from "@/core/interface";
import { message } from "ant-design-vue";
import ArrayToTree from "array-to-tree";
import {
  CategoryDetailResp,
  CategoryListRecord,
  CategoryListReq,
  CategoryListResp,
  CategoryReq,
  CategorySimpleListResp,
} from "./category.interface";

export class CategoryService {
  static async fetchList(params: CategoryListReq): Promise<CategoryListRecord[]> {
    let records: CategoryListRecord[] = [];
    try {
      const r: AxiosResponse<ResponseResp<CategoryListResp>> = await HttpService.axios({
        method: "GET",
        url: "/material_category/full/list",
        params,
      });
      const res = r.data;
      if (res.respCode !== "0000") {
        message.error(res.respDesc);
        return records;
      }
      records = (res.data.records || []).map((item) => {
        if (item.hasChildren) {
          item.children = [];
        }
        return item;
      });
    } catch (e: any) {
      message.error(e.message);
    }
    return records;
  }

  static attachChildren(list, parentId, children) {
    const recurse = (list, children) => {
      return (list || []).map((item) => {
        if (item.id === parentId) {
          item.children = children || [];
        } else {
          if (item.children) {
            item.children = recurse(item.children, children);
          }
        }
        return item;
      });
    };
    return recurse(list, children);
  }

  static useFullListApi() {
    const api = (params) =>
      HttpService.axios({
        method: "GET",
        url: "/material_category/full/list",
        params,
      });
    return HttpService.useRequest<CategoryListResp>(api);
  }

  static useSimpleListApi() {
    const api = () =>
      HttpService.axios({
        method: "GET",
        url: `/material_category/simple/list`,
      });
    return HttpService.useRequest<CategorySimpleListResp>(api, {
      formatResult: (resp) => {
        resp.treeRecords = ArrayToTree(resp.records || [], {
          parentProperty: "parentId",
          customID: "id",
        });
        return resp;
      },
    });
  }

  static useSimpleListWithAllApi() {
    const api = () =>
      HttpService.axios({
        method: "GET",
        url: `/material_category/simple/listWithAll`,
      });
    return HttpService.useRequest<CategorySimpleListResp>(api, {
      formatResult: (resp) => {
        resp.treeRecords = ArrayToTree(resp.records || [], {
          parentProperty: "parentId",
          customID: "id",
        });
        return resp;
      },
    });
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/material_category/${id}`,
      });
    return HttpService.useRequest<CategoryDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: CategoryReq) =>
      HttpService.axios({
        method: "POST",
        url: "/material_category",
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useEditApi() {
    const api = (id: string, data: CategoryReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/material_category/${id}`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "POST",
        url: `/material_category/${id}/delete`,
      });
    return HttpService.useRequest<void>(api);
  }
}
